import template from './email-detail.html';
import controller from './email-detail.controller';

let emailDetailComponent = {
  bindings: {},
  template,
  controller
};

export default emailDetailComponent;



// WEBPACK FOOTER //
// ./client/app/components/email/email-detail.component.js